import BusinessLegalDrafting from "./BusinessLegalDrafting";
import BusinessLegalServices from "./BusinesslegalServices";
import CustomerAgreement from "./CustomerAgreement";
import CustomerLitigation from "./CustomerLitigation";
import  JointVenture  from "./JointVenture";
import LandLitigation from "./LandLitigation";
import LandTitle from "./LandTitle";

export default BusinessLegalServices;
export {JointVenture,BusinessLegalDrafting,CustomerAgreement,CustomerLitigation,LandLitigation,LandTitle};
